import { Check, Delete, OpenInNew } from "@mui/icons-material";
import { Box, Card, CardActionArea, CardContent, Checkbox, Chip, IconButton, Tooltip, tooltipClasses, Typography } from "@mui/material";
import { Fragment } from "react";
import { styled } from '@mui/material/styles';

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}))

function stripHtml(html = "") {
    const tmp = document.createElement("div")
    tmp.innerHTML = html;
    return tmp.textContent || ""
}

function formatDate(str) {
    if (!str) return "";
    return new Date(str).toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    })
}

function handleOpenInNewTab(id) {
    const url = `/${this.props.match.params.lang}/faq/${id}`
    window.open(url, "_blank")
}

const FaqCard = ({ item, onClick, onDelete, selectable = false, selected = false }) => {
    const answer = stripHtml(item.answer)

    return (
        <Card
            variant="outlined"
            sx={{
                position: 'relative',
                borderColor: "divider",
                borderWidth: 1,
                bgcolor: "background.paper",
                height: "100%",
            }}
        >
            {
                !selectable && (
                    <Box
                        sx={{
                            position: "absolute",
                            top: 6,
                            right: 6,
                            display: "flex",
                            gap: 0.5,
                            zIndex: 2,
                        }}
                    >
                        {/* <IconButton
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation()
                                handleOpenInNewTab(item.id)
                            }}
                        >
                            <OpenInNew fontSize="small" />
                        </IconButton> */}
                    </Box>
                )
            }
            <CardActionArea
                onClick={() => onClick(item.id)}
                disableRipple={false}
                sx={{ height: "100%", alignItems: "flex-start" }}

            >
                <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1, height: "100%" }}>

                    {/* Top: checkbox + título */}
                    <Box display="flex" alignItems="flex-start" gap={1}>
                        {selectable && <Checkbox
                            checked={selected}
                            size="small"
                            disableRipple
                            tabIndex={-1}
                            sx={{ p: 0, mt: "2px", flexShrink: 0, pointerEvents: "none" }}
                        />}

                        <Typography variant="subtitle2" fontWeight={600} lineHeight={1.4}>
                            {item.id}
                        </Typography>
                    </Box>

                    <Typography variant="subtitle2" fontWeight={600} lineHeight={1.4}>
                        {item.question}
                    </Typography>

                    {answer && (
                        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>
                            {answer.length > 110 ? answer.slice(0, 110) + "…" : answer}
                        </Typography>
                    )}

                    {/* Tempo de leitura */}
                    {item.readingtime && (
                        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>
                            {item.readingtime.length > 110 ? item.readingtime.slice(0, 110) + "…" : item.readingtime}
                        </Typography>
                    )}

                    {/* Meta: autor + data */}
                    <Typography variant="caption" color="text.disabled">
                        por {item.createduser} · {formatDate(item.createdat)}
                    </Typography>

                </CardContent>
                {
                    !selectable &&
                    (
                        <Box
                            sx={{
                                position: "absolute",
                                bottom: 6,
                                right: 6,
                                display: "flex",
                                gap: 0.5,
                                zIndex: 2,
                            }}
                        >
                            <IconButton
                                size="small"
                                color="error"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    onDelete(item)
                                }}
                            >
                                <Delete fontSize="small" />
                            </IconButton>
                        </Box>
                    )
                }
            </CardActionArea>
        </Card>
    )
}

export default FaqCard